export default "__VITE_ASSET__jwD$jXry__"